export default "__VITE_ASSET__BMnHYnGV__"